<template>
  <div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>บัญชีแสดงสัญญา</label>
        <span class="required"><font color="red">*</font></span>
        <input @keypress="isNumber($event)"
        v-model="caNo" 
        name="caNo" 
        v-validate="{required:true,max:20}"
        :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"

        :class="{'input': true, 'is-danger': errors.has('caNo') }"
        type="number" class="form-control" placeholder="">
        <span
        v-show="errors.has('caNo')"
        class="help is-danger"
        >กรอก บัญชีแสดงสัญญา</span>        
      </div>
      <div class="form-group col-md-6">
        <label>เครื่องวัดหน่วยไฟฟ้า</label>
        <span class="required" v-if="caNo.substring(0, 2)!=='90'"><font color="red">*</font></span>
        <input @keypress="isNumber($event)"
        v-model="meterNo" 
        name="meterNo" 
        v-validate="{required:true,max:20}"
        
        :disabled="caNo.substring(0, 2)=='90'||(this.reqType !== 1  && this.appVo.modifyFlag!=='Y')"
        :class="{'input': true, 'is-danger': errors.has('meterNo') }"
        type="number" class="form-control" placeholder="">
        <span
        v-show="errors.has('meterNo')"
        class="help is-danger"
        >กรอก เครื่องวัดหน่วยไฟฟ้า</span>     

      </div>
    </div>

  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ["reqType","appVo"],
  data() {
    return {
      caNo: "",
      meterNo: "",
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.caNo = this.appVo.caNo;
      this.meterNo = this.appVo.meterNo;
    }
  },  
  watch: {
    caNo(newval, oldval) {
      if(newval.substring(0, 2)=="90"){
        this.meterNo = "";
      }
      this.$emit("childToParent", {
        caNo: this.caNo,
        meterNo: this.meterNo,
      });
    },
    meterNo(newDate, oldDate) {
      this.$emit("childToParent", {
        caNo: this.caNo,
        meterNo: this.meterNo,
      });
    },
  },methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  }
};
</script>